<template>
  <SelectComponent :value="value" class="contact-select-modal" @input="$ev => $emit('input', $ev)" v-bind="$attrs">
    <template #item="{ item, scope }">
      <ContactCard theme="list" :value="item" :subtitle="[item.email, item.phone].filter(Boolean).join(' | ')">
        <template #custom>
          <slot v-if="scope === 'input'" :item="item" :scope="scope" name="custom" />
        </template>
      </ContactCard>
    </template>
    <template #empty>
      <ContactCard theme="list" :value="{ name: labels.notset }" :subtitle="subtitle" />
    </template>
    <template #noresults="{ filter }">
      <div class="text--center">{{ $t('couldnotfindonquery', { query: filter.search }) }}</div>
    </template>
    <template #bottom>
      <div class="contact-select-modal__add-contact">
        {{ $t('lookingForAContactAdd') }}
        <router-link :to="{ name: 'contact-create', query: { returnTo: $route.path } }">{{
          $t('createContact')
        }}</router-link>
      </div>
    </template>
  </SelectComponent>
</template>

<script>
import ContactCard from './Card'
import SelectComponent from '@/components/Select/Modal'
import { mapi18n } from '@/i18n'

export default {
  props: {
    value: [Object, Array],
    subtitle: String,
  },
  computed: {
    ...mapi18n('labels', ['notset']),
  },
  components: {
    ContactCard,
    SelectComponent,
  },
}
</script>

<style lang="scss">
.contact-select-modal {
  &__add-contact {
    text-align: center;
    color: css-alpha('dark', 0.5);
    font-size: 0.8em;
    padding: 1rem;

    a {
      display: block;
      margin-top: 5px;
    }
  }
}
</style>
